import React, { useEffect } from 'react'
import styled from 'styled-components'
import {motion} from 'framer-motion'
import Me from '../assets/Images/profile-img.png'


const Box = styled(motion.div)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  width: 65vw;
  height: 55vh;
  display: flex;

  /* Desktop layout - horizontal with left/right split */
  background: linear-gradient(
      to right,
      ${(props) => props.theme.body} 50%,
      ${(props) => props.theme.text} 50%
    )
    bottom,
    linear-gradient(
      to right,
      ${(props) => props.theme.body} 50%,
      ${(props) => props.theme.text} 50%
    )
    top;
  background-repeat: no-repeat;
  background-size: 100% 2px;

  border-left: 2px solid ${(props) => props.theme.body};
  border-right: 2px solid ${(props) => props.theme.text};

  z-index: 1;

  /* Large desktop screens */
  @media (min-width: 1600px) {
    width: 60vw;
    height: 60vh;
  }

  @media (min-width: 1400px) and (max-width: 1599px) {
    width: 62vw;
    height: 58vh;
  }

  @media (max-width: 1200px) {
    width: 60vw;
    height: 55vh;
  }

  @media (max-width: 1024px) {
    width: 58vw;
    height: 52vh;
  }

  @media (max-width: 900px) {
    width: 55vw;
    height: 50vh;
  }

  @media (max-width: 768px) {
    width: 55vw;
    height: 50vh;
  }

  @media (max-width: 600px) {
    width: 50vw;
    height: 45vh;
  }

  @media (max-width: 480px) {
    width: 45vw;
    height: 45vh;
    flex-direction: column;
    padding: 2px; /* Add padding to create space for borders */
    box-sizing: border-box; /* Ensure proper sizing */

    /* Desktop-style split borders for top and bottom - consistent 2px width */
    background: linear-gradient(
        to right,
        ${(props) => props.theme.body} 50%,
        ${(props) => props.theme.text} 50%
      )
      bottom,
      linear-gradient(
        to right,
        ${(props) => props.theme.body} 50%,
        ${(props) => props.theme.text} 50%
      )
      top;
    background-repeat: no-repeat;
    background-size: 100% 2px;

    /* Add left and right borders for consistency */
    border-left: 2px solid ${(props) => props.theme.body};
    border-right: 2px solid ${(props) => props.theme.text};
  }

  @media (max-width: 400px) {
    width: 42vw;
    height: 42vh;
  }

  @media (max-width: 320px) {
    width: 40vw;
    height: 40vh;
  }
`;





const SubBox = styled.div`
width: 50%;
position: relative;
display: flex;

.pic{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%,0%);
    width: 100%;
    height: auto;
}

/* Large desktop screens */
@media (min-width: 1600px) {
    .pic {
        width: 95%;
    }
}

@media (min-width: 1400px) and (max-width: 1599px) {
    .pic {
        width: 92%;
    }
}

@media (max-width: 1200px) {
    .pic {
        width: 90%;
    }
}

@media (max-width: 1024px) {
    .pic {
        width: 88%;
    }
}

@media (max-width: 900px) {
    .pic {
        width: 85%;
    }
}

@media (max-width: 768px) {
    .pic {
        width: 90%;
    }
}

@media (max-width: 600px) {
    .pic {
        width: 85%;
    }
}

@media (max-width: 480px) {
    width: 100%;
    height: 50%;
    
    /* Mobile only: explicit background colors for each section */
    &:first-child {
        background-color: ${props => props.theme.body};
    }
    
    &:last-child {
        background-color: ${props => props.theme.text};
    }
    
    .pic {
        width: auto;
        height: 100%;
    }
}

@media (max-width: 400px) {
    .pic {
        width: auto;
        height: 95%;
    }
}

@media (max-width: 320px) {
    .pic {
        width: auto;
        height: 90%;
    }
}
`

const Text = styled.div`
font-size: calc(1em + 1.5vw);
color: ${props => props.theme.body};
padding: 2rem;
cursor: pointer;

display: flex;
flex-direction: column;
justify-content: space-evenly;

&>*:last-child{
    color: ${props => `rgba(${props.theme.bodyRgba},0.6)` };
    font-size: calc(0.5rem + 1.5vw);
    font-weight:300;
}

/* Large desktop screens */
@media (min-width: 1600px) {
    padding: 2.5rem;
    font-size: calc(1.2em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.6rem + 1.5vw);
    }
}

@media (min-width: 1400px) and (max-width: 1599px) {
    padding: 2.3rem;
    font-size: calc(1.1em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.55rem + 1.5vw);
    }
}

@media (max-width: 1200px) {
    padding: 2.2rem;
    font-size: calc(1em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.5rem + 1.5vw);
    }
}

@media (max-width: 1024px) {
    padding: 2rem;
    font-size: calc(0.9em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.45rem + 1.5vw);
    }
}

@media (max-width: 900px) {
    padding: 1.8rem;
    font-size: calc(0.85em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.42rem + 1.5vw);
    }
}

@media (max-width: 768px) {
    padding: 1.5rem;
    font-size: calc(0.8em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.4rem + 1.5vw);
    }
}

@media (max-width: 600px) {
    padding: 1.2rem;
    font-size: calc(0.7em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.35rem + 1.5vw);
    }
}

@media (max-width: 480px) {
    padding: 1rem;
    font-size: calc(0.6em + 1.5vw);
    color: ${props => props.theme.text}; /* Mobile only: dark text on light background */
    
    &>*:last-child{
        font-size: calc(0.3rem + 1.5vw);
        color: ${props => `rgba(${props.theme.textRgba},0.6)` }; /* Mobile only: adjust opacity text */
    }
}

@media (max-width: 400px) {
    padding: 0.8rem;
    font-size: calc(0.55em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.28rem + 1.5vw);
    }
}

@media (max-width: 320px) {
    padding: 0.6rem;
    font-size: calc(0.5em + 1.5vw);
    
    &>*:last-child{
        font-size: calc(0.25rem + 1.5vw);
    }
}
`

const Intro = ({ click }) => {
    return (
        <Box
        initial={{height:0, opacity: 0}}
        animate={click ? {height: '55vh', opacity: 1} : {height: 0, opacity: 0}}
        transition={{ type: 'spring', duration: 1, delay: 0.2 }}
        style={{ pointerEvents: click ? 'auto' : 'none' }}
        >
            <SubBox>
                <Text>
                    <h1>Hi,</h1>
                    <h3>I'm Pratik.</h3>
                    <h6>I'm a self-driven and passionate Software Developer who enjoys solving real-world problems through thoughtful design and clean, efficient code.</h6>
                </Text>
            </SubBox>
            <SubBox>
                <motion.div
                initial={{opacity:0}}
                animate={click ? {opacity: 1} : {opacity: 0}}
                transition={{ duration:1, delay: click ? 1 : 0 }}
                >
                    <img className="pic" src={Me} alt="Profile Pic" />
                </motion.div>
            </SubBox>
        </Box>
    )
}

export default Intro